// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"swipeToConfirm_outerContainer__2ZAnT","slider":"swipeToConfirm_slider__1FXsf"};